<template>
  <div class="notifications" v-if="notifications.length > 0">
    <div
      v-for="notification in notifications"
      :class="`notification ${notification.state}`"
      :key="notification.id"
    >
      <div class="d-f f-w m-b-1">
        <p>{{ notification.message }}</p>
        <p v-if="notification.secondaryMessage" class="ml-a">{{ notification.secondaryMessage }}</p>
      </div>
      <template v-if="notification.button">
        <Button
          :icon="notification.button.icon"
          :class="`${notification.button.class} justify-left f-w`"
          @click="notification.button.func ? notification.button.func() : null"
        >{{ notification.button.text }}</Button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * Get all notifications that has top-bar type
     * @returns {Array}
     */
    notifications() {
      return this.$store.getters['Notifications/get']('menu-bar');
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar.collapsed .notifications {
  @media (min-width: 768px) {
    display: none;
  }
}

.notifications {
  width: 100%;
}

.notification {
  align-items: center;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  background-color: #FFF3CB;
  box-shadow: 0 1px 0 0 #E8D4BE;
  padding: 6px 15px;
  flex-wrap: wrap;
  margin: 0 8px;

  p {
    color: black;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;

    &:nth-child(2) {
      font-weight: 400;
    }
  }

  &.warning {
    background: #F73131;
    box-shadow: 0 1px 0 0 #DB1B1B;

    p {
      color: white;
    }
  }
}
</style>
